module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAWCAMAAABHYGoGAAAANlBMVEUAAAD+Z37+Z37+Z37+Z37+Z37+Z37+Z37+Z37+Z37+Z37+Z37+Z37+Z37+Z37+Z37+Z37+Z34Id10eAAAAEXRSTlMA5+Lb1ycgGhTMD/HRR760Ls9HjlgAAABpSURBVDjLxZQ7FoAwDMNIS/mVArr/ZVl4gbXxgHZrSezB2Y5a6cWa55eVCOb5nRhPfh4J4nlJMGUkwZSQBCUhCYohCS5DE2T+FhRDQj0C6hugPiJqFfQyqXOAOEjwTmLMkD6jelqil9xus5xVWmFaR+wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/act/march_promotion/img/rectangle.png
// module id = 215
// module chunks = 0